import UtilizationHistory from './UtilizationHistory';

export default UtilizationHistory;
